import {useContext, useMemo} from "react";

import {BillingService} from "../../../services";
import {HTTPContext} from "../../contexts";

export const useBillingService = () => {
    const http = useContext(HTTPContext);
    return useMemo(() => new BillingService(http), [http]);
};
